import {
    type GetUploadTokenForCompanyPhotoResponseType,
    type GetUploadTokenForCompanyPhotoRequestType
} from "./type";
import {
    request
} from "../request";

const GetUploadTokenForCompanyPhoto = async (params: GetUploadTokenForCompanyPhotoRequestType): Promise<GetUploadTokenForCompanyPhotoResponseType> => {
    return await request<GetUploadTokenForCompanyPhotoResponseType>("/company/getUploadTokenForCompanyPhoto", {
        body: JSON.stringify(params),
        method: "POST"
    });
};

export default GetUploadTokenForCompanyPhoto;
